import React from 'react'
import { Helmet } from 'react-helmet-async'
import "./problemimpact.css"

// images
import icon1 from "../../components/assets/impact/accountabilityicon.png"
import icon2 from "../../components/assets/impact/environmentalcareicon.png"
import icon3 from "../../components/assets/impact/innovationicon.png"

function Problemimpact() {
  return (
    <div>
      <Helmet>
        <title>The Problem We Solve, The Impact We Create - Enteeon</title>
        <meta name="description" content="Discover how Enteeon addresses India's growing bio-waste management challenges and protein demand through sustainable black soldier fly technology, creating high-protein feed and organic manure." />
        <meta name="keywords" content="problem impact, sustainable farming, bio-waste management, black soldier fly, protein feed, organic manure, CO2 reduction, Enteeon" />
        <meta property="og:title" content="The Problem We Solve, The Impact We Create - Enteeon" />
        <meta property="og:description" content="Discover how Enteeon addresses India's growing bio-waste management challenges and protein demand through sustainable black soldier fly technology, creating high-protein feed and organic manure." />
        <meta property="og:image" content="https://enteeon.com/assets/impact/impact-bg.jpg" />
        <meta property="og:url" content="https://enteeon.com/problemimpact" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="The Problem We Solve, The Impact We Create - Enteeon" />
        <meta name="twitter:description" content="Discover how Enteeon addresses India's growing bio-waste management challenges and protein demand through sustainable black soldier fly technology, creating high-protein feed and organic manure." />
        <meta name="twitter:image" content="https://enteeon.com/assets/impact/impact-bg.jpg" />
      </Helmet>
        {/* impact-hero-section starts here*/}
        <section className="problem-impact-section">
      <div className="container">
        <div className="row justify-content-center text-center">
          <div className="col-lg-10 col-md-12">
            <h2 className="problem-impact-h1 bold">
              The Problem <span className="highlight1">We Solve,</span>
            </h2>
            <h2 className="problem-impact-h2 bold">
              The Impact <span className="highlight2">We Create.</span>
            </h2>
          </div>
        </div>
      </div>
    </section>
        {/* impact-hero-section ends here */}

        {/* the problem statement starts here */}
        <section className="problem-section">
      <div className="container">
        <div className="row justify-content-center text-center">
          <div className="col-lg-8 col-md-10">
            <h2 className="problem-title">The Problem,</h2>
            <p className="problem-text">
              With India’s population projected to reach 1.6 billion by 2050, managing the growing bio-waste and 
              meeting the rising protein demand is critical. Improper waste management contributes to pollution and 
              diseases, while traditional protein sources like soy and fishmeal are unsustainable and costly.
            </p>
          </div>
        </div>
      </div>
    </section>
        {/* the problem statement ends here */}

        {/* the impact starts here */}
        <section className="impact-section position-relative">
      <div className="container">
        <div className="row justify-content-center text-center">
          <div className="col-lg-8 col-md-10">
            <h2 className="impact-title">The Impact.</h2>
            <ul className="impact-list">
              <li>
                <strong>Convert Biowaste:</strong> Process organic waste into high-protein larvae and nutrient-rich frass in 5 days.
              </li>
              <li>
                <strong>Provide Sustainable Feed:</strong> Offers <strong>~40% of Protein</strong> which is organic, cost-effective feed for poultry, aquaculture, and exotic animals.
              </li>
              <li>
                <strong>Produce Organic Manure:</strong> Deliver nutrient-rich frass for soil health and pest control.
              </li>
              <li>
                <strong>CO2 Emission is Taken Control:</strong> The Carbon Emission by Biowaste is <strong>reduced by ~70%</strong> compared to conventional methods.
              </li>
              <li>
                <strong>Revenue Streams:</strong> Through BSF we extract - Proteins, Organic Composts, Chitosan which serves as a raw material for Applied Bio Science, Pharmaceutical, and Cosmeceutical industries.
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
        {/* the impact ends here */}

        {/* mission | Vision statement starts here*/}
        <section className="mission-vision-section position-relative">
      <div className="container">
        <div className="row justify-content-center align-items-center">
          {/* Mission Section */}
          <div className="col-md-5 text-center text-md-end mission-text">
            <h2 className="section-title vmsection-title">Mission.</h2>
            <p className="section-text vmsection-text">
              To lead the way in sustainable farming and waste management, focusing on converting 
              organic biowaste into high-quality protein sources and upcycles waste into valuable 
              animal feed and organic manure, Chitosan redefining waste management and 
              sustainable farming.
            </p>
          </div>

          {/* Divider */}
          <div className="col-md-2 d-none d-md-block text-center">
            <div className="divider"></div>
          </div>

          {/* Vision Section */}
          <div className="col-md-5 text-center text-md-start vision-text">
            <h2 className="section-title vmsection-title">Vision.</h2>
            <p className="section-text vmsection-text">
              In a future where waste is seen as a resource, farming thrives sustainably and 
              creates eco-friendly solutions that empower farmers and protect the environment.
            </p>
          </div>
        </div>
      </div>
    </section>
        {/* mission | Vision statement ends here */}

        {/* corevalues section starts here */}
        <section className="core-values-section position-relative">
      <div className="container text-center">
        <h2 className="core-values-title">Core Values.</h2>
        <div className="row justify-content-center">
          {/* Accountability */}
          <div className="col-md-4 core-value">
            <img src={icon1} alt="Accountability" className="core-value-icon" />
            <h3 className="core-value-title">Accountability -</h3>
            <p className="core-value-text">We stand by our commitments.</p>
          </div>

          {/* Environmental Care */}
          <div className="col-md-4 core-value">
            <img src={icon2} alt="Environmental Care" className="core-value-icon" />
            <h3 className="core-value-title">Environmental Care -</h3>
            <p className="core-value-text">We’re driven to protect the planet.</p>
          </div>

          {/* Innovation */}
          <div className="col-md-4 core-value">
            <img src={icon3} alt="Innovation" className="core-value-icon" />
            <h3 className="core-value-title">Innovation -</h3>
            <p className="core-value-text">We push boundaries to create better solutions.</p>
          </div>
        </div>
      </div>
    </section>
        {/* corevalues section ends here */}

    </div>
  )
}

export default Problemimpact